export default "__VITE_ASSET__CiIP4Dut__"